import { theme } from "antd";
import { PropsWithChildren, ReactElement } from "react";
import { ThemeProvider } from "styled-components";

export default function StyledThemeProvider({ children }: PropsWithChildren): ReactElement {
  const { token } = theme.useToken();

  return (
    <ThemeProvider theme={token}>
      {children}
    </ThemeProvider>
  );
}
